export default "__VITE_ASSET__9af982af__"